import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './routing/app-routing.module';
import { AppComponent } from './components/app/app.component';

import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//Google Login
import { SocialLoginModule, SocialAuthServiceConfig } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';

// firebase libs
import { AngularFireModule } from '@angular/fire';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth'

//environment variables
import { environment } from '../environments/environment';

import { AuctionService } from './services/auction.service';
import { DataService } from './services/data.service';
import { FeedsService } from './services/feeds.service';
import { AuthService } from './services/auth.service';
import { ProductService } from './services/product.service';
import { UserService } from './services/user.service';
import { FirebaseService } from './services/firebase.service';
import { BidStatusPipe } from './pipes/bidstatus.pipe';
import { FeedsComponent } from './components/feeds/feeds.component';
import { ErrorpageComponent } from './components/errorpage/errorpage.component';
import { HomeComponent } from './components/home/home.component';
import { BaseformComponent } from './components/home/baseform/baseform.home.component';
import { ExpandedFormComponent } from './components/home/expandedform/expandedform.home.component';
import { ProductsComponent } from './components/home/products/products.home.component';
import { ProductItemComponent } from './components/home/products/productItem/productItem.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ProductInfoComponent } from './components/productinfo/productinfo.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { MyProductsComponent } from './components/myproducts/myproducts.component';
import { MyProductItemComponent } from './components/myproducts/productItem/productItem.component';
import { EditProductComponent } from './components/editproduct/editproduct.component';
import { LoadImagePipe } from './pipes/loadimage.pipe';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    BaseformComponent,
    ExpandedFormComponent,
    ProductsComponent,
    ProductItemComponent,
    MyProductsComponent,
    MyProductItemComponent,
    EditProductComponent,
    FeedsComponent,
    ErrorpageComponent,
    ProductInfoComponent,
    BidStatusPipe,
    LoadImagePipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    SocialLoginModule,
    ToastrModule.forRoot({ "positionClass": "toast-bottom-right" }),
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireStorageModule,
    AngularFireAuthModule,
  ],
  providers: [
    AuctionService,
    AuthService,
    DataService,
    FeedsService,
    FirebaseService,
    ProductService,
    UserService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              environment.google_client_ID
            )
          }
        ]
      } as SocialAuthServiceConfig,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
